import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisbursementType } from 'src/app/core/services/loan-application/disbursement/disbursement.model';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';

export interface DebitCardErrorDialogData {
	disbursementType: DisbursementType;
	address?: string;
	accountLast4?: string;
}

@Component({
	selector: 'op-debit-card-error-dialog',
	templateUrl: './debit-card-error-dialog.component.html',
	styleUrls: ['./debit-card-error-dialog.component.scss']
})
export class DebitCardErrorDialogComponent implements OnInit {
	readonly disbursementType: typeof DisbursementType = DisbursementType;

	constructor(
		public dialogRef: MatDialogRef<DebitCardErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DebitCardErrorDialogData,
		private tagDataService: TagDataService
	) {}

	ngOnInit() {
		this.tagDataService.link(
			{},
			{
				tealium_event: `debit card update error`
			}
		);
	}

	onClick(): void {
		this.dialogRef.close(true);
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}
}
